/** Central route identifiers. Never hard-code an admin path in JSX. */
export const ROUTES = {
  signIn: '/admin/sign-in',
  forgotPassword: '/admin/forgot-password',
  resetPassword: '/admin/reset-password/$token',
  verifyEmail: '/admin/verify-email',
  dashboard: '/admin/dashboard',
  users: '/admin/users',
  userNew: '/admin/users/new',
  userDetail: '/admin/users/$userId',
  userEdit: '/admin/users/$userId/edit',
  projects: '/admin/projects',
  projectDetail: '/admin/projects/$projectId',
  invoices: '/admin/invoices',
  notifications: '/admin/notifications',
  notificationNew: '/admin/notifications/new',
  notificationDetail: '/admin/notifications/$notificationId',
  notificationEdit: '/admin/notifications/$notificationId/edit',
  pipeRatePredictions: '/admin/pipe-rate-predictions',
  pipeRatePredictionDetail: '/admin/pipe-rate-predictions/$pipeType',
  banners: '/admin/banners',
  advertisement: '/admin/advertisement',
  tutorials: '/admin/tutorials',
  calculationSettings: '/admin/platform-settings/calculation',
  reportPricing: '/admin/platform-settings/report-pricing',
  reportProTips: '/admin/platform-settings/report-pro-tips',
  privacyPolicy: '/admin/platform-settings/privacy-policy',
  termsConditions: '/admin/platform-settings/terms-conditions',
  platformSettings: '/admin/platform-settings',
  prototypeControls: '/admin/prototype-controls',
  profile: '/admin/profile',
  changePassword: '/admin/change-password',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];

/** Routes a notification deep-link is allowed to target. */
export const REGISTERED_EVENT_ROUTES: readonly string[] = [
  ROUTES.users,
  ROUTES.projects,
  ROUTES.invoices,
  ROUTES.dashboard,
];
